/**
 * Icon registry, so content files can name an icon as a string and sections
 * can resolve it with <component :is="resolveIcon(item.icon)" />.
 */
import IconAccessibility from "./IconAccessibility.vue";
import IconArrow from "./IconArrow.vue";
import IconBell from "./IconBell.vue";
import IconCalendar from "./IconCalendar.vue";
import IconChart from "./IconChart.vue";
import IconCheck from "./IconCheck.vue";
import IconChevron from "./IconChevron.vue";
import IconClipboard from "./IconClipboard.vue";
import IconClock from "./IconClock.vue";
import IconClose from "./IconClose.vue";
import IconGlobe from "./IconGlobe.vue";
import IconHeart from "./IconHeart.vue";
import IconHelp from "./IconHelp.vue";
import IconMail from "./IconMail.vue";
import IconMenu from "./IconMenu.vue";
import IconPalette from "./IconPalette.vue";
import IconPhone from "./IconPhone.vue";
import IconPlay from "./IconPlay.vue";
import IconQuote from "./IconQuote.vue";
import IconRuler from "./IconRuler.vue";
import IconShield from "./IconShield.vue";
import IconSparkle from "./IconSparkle.vue";
import IconStar from "./IconStar.vue";
import IconUsers from "./IconUsers.vue";

export const icons = {
  IconAccessibility,
  IconArrow,
  IconBell,
  IconCalendar,
  IconChart,
  IconCheck,
  IconChevron,
  IconClipboard,
  IconClock,
  IconClose,
  IconGlobe,
  IconHeart,
  IconHelp,
  IconMail,
  IconMenu,
  IconPalette,
  IconPhone,
  IconPlay,
  IconQuote,
  IconRuler,
  IconShield,
  IconSparkle,
  IconStar,
  IconUsers,
};

export function resolveIcon(name) {
  return icons[name] || IconSparkle;
}
